var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "headerReturnItem" }, [
    _c(
      "div",
      {
        staticClass: "title-con flex flex-center-2",
        staticStyle: { "justify-content": "flex-start" },
      },
      [
        _vm.isBtnShow
          ? _c("div", { staticClass: "return-btn-con" }, [
              _c("span", {
                staticClass: "return-btn el-icon-arrow-left",
                on: { click: _vm.onBackHandle },
              }),
            ])
          : _vm._e(),
        _vm.title
          ? _c("h1", { staticClass: "case-title" }, [_vm._v(_vm._s(_vm.title))])
          : _vm._e(),
        _vm.isCustom ? _c("div", [_vm._t("customTitle")], 2) : _vm._e(),
        _c("div", { staticClass: "block" }),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }